import React from "react";
import { ThemeProvider } from "@mui/material/styles";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import WishList from "./pages/WishList";

import Main from "./pages/Main";
import Find from "./pages/Find";
import Home from "./pages/Home";
import Places from "./pages/Places";
import SignUp from "./pages/SignUp";
import Festival from "./pages/Festival";
import Search from "./pages/Search";
import Setting from "./pages/Setting";
import Profile from "./pages/Profile";
import Culture from "./pages/Culture";
import theme from "./theme";
import AuthRedirect from "./AuthRedirect";
import AuthCallback from "./pages/AuthCallback";
import PlaceEdit from "./pages/PlaceEdit";

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <AuthRedirect /> {/* 로그인 상태 감지 후 리디렉션 */}
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/home" element={<Home />} />
          <Route path="/main" element={<Main />} />
          <Route path="/find" element={<Find />} />
          <Route path="/festival" element={<Festival />} />
          <Route path="/search" element={<Search />} />
          <Route path="/setting" element={<Setting />} />
          <Route path="/places" element={<Places />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/culture" element={<Culture />} />
          <Route path="/wishlist" element={<WishList />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/auth/callback" element={<AuthCallback />} /> {/* 추가 */}
          <Route path="/place/edit/:placeId?" element={<PlaceEdit />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default App;
